import { gql } from 'graphql-request';

export const FIELD_YIELD_DATA_QUERY = gql`
  query GetFieldYieldData($id: ID!, $cropId: ID) {
    field(id: $id) {
      harvestEventAggregates(cropId: $cropId) {
        averageYield {
          u v
        }
        maximumYield {
          u v
        }
      }
    }
  }
`;
